
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __appWithI18n from 'next-translate/appWithI18n'
// @ts-ignore
    
import { Loading } from 'components/Loading/Loading';
import { LoadingContextProvider } from 'context/LoadingContext';
import type { AppProps } from 'next/app';
import 'styles/theme.css';
import 'styles/toast.css';
import { GlobalContextProvider } from 'context/GlobalContext';
import { ReactElement, ReactNode, useEffect, useState } from 'react';
import { NextPage } from 'next';
import Head from 'next/head';
import { AuthContextProvider } from '../context/AuthContext';
import { UnsavedChangesModal } from 'components/UI/Modals/UnsavedChangesModal/UnsavedChangesModal';
import { UnsavedChangesContextProvider } from 'context/UnsavedChangesContext';
import { DesignSystemProvider } from '@atvlibs/atvdesignsystem';

type ComponentWithLayout = NextPage & {
	getLayout?: (page: ReactElement) => ReactNode;
};

interface PageWithLayout extends AppProps {
	Component: ComponentWithLayout;
}

const __Page_Next_Translate__ = function App({ Component, pageProps }: PageWithLayout) {
	const mockingEnabled = process.env.NEXT_PUBLIC_API_MOCKING === 'enabled';
	const [shouldRender, setShouldRender] = useState(!mockingEnabled);
	const [isHydrated, setIsHydrated] = useState<boolean>(false);
	const getLayout = Component.getLayout ?? ((page) => page);

	useEffect(() => {
		setIsHydrated(true);
		if (mockingEnabled) {
			import('../api/mock').then(async ({ initMocks }) => {
				await initMocks();
				setShouldRender(true);
			});
		}
	}, []);

	if (!isHydrated) return null;

	return shouldRender ? (
		<>
			<Head>
				<title>ATV Wizard</title>
				<meta
					name="viewport"
					content="minimum-scale=1, initial-scale=1, width=device-width"
				/>
			</Head>
			<DesignSystemProvider>
				<AuthContextProvider>
					<LoadingContextProvider>
						<GlobalContextProvider>
							<UnsavedChangesContextProvider>
								<>
									<UnsavedChangesModal />
									{getLayout(<Component {...pageProps} />)}
									<Loading />
								</>
							</UnsavedChangesContextProvider>
						</GlobalContextProvider>
					</LoadingContextProvider>
				</AuthContextProvider>
			</DesignSystemProvider>
		</>
	) : (
		<>Loading mocks...</>
	);
}


// @ts-ignore
    export default __appWithI18n(__Page_Next_Translate__, {
// @ts-ignore
      ...__i18nConfig,
// @ts-ignore
      isLoader: true,
// @ts-ignore
      skipInitialProps: true,
// @ts-ignore
      loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
    });
// @ts-ignore
  